import { InjectionToken } from '@angular/core';

export interface Environment {
	production: boolean,
  msalConfig: {
		auth: {
			clientId: string;
			authority: string;              // p.ej. https://login.microsoftonline.com/<tenantId>
			redirectUri: string;            // p.ej. window.location.origin
			postLogoutRedirectUri?: string;
		}
	}  
	apiConfig: {
  	scopes: string[];         // p.ej. ['User.Read']
		uri: string
	},
	internalApi: {
		key: string
	},
	baseUrl: {
		auth: string,
		data: string, 
	},
	logoutUrl: string,
	postHogKey: string
}

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT');